import { useCallback, useMemo } from "react";
import apiClient from "../../api/axios";
import { ExtractedContract } from "../../types/contract";

export const useFileOperations = (selectedContract: ExtractedContract | null) => {
  const handleOpenFile = useCallback(async (originalFilename: string) => {
    if (!originalFilename || !selectedContract) return;

    try {
      let fileToFetch: string;

      if (!selectedContract.filename_uuid_map) {
        // Legacy data → use original filename
        fileToFetch = originalFilename;
      } else {
        // UUID data → get UUID from mapping
        const uuidMap = JSON.parse(selectedContract.filename_uuid_map);
        fileToFetch = uuidMap[originalFilename];
        if (!fileToFetch) {
          alert("ファイルマッピングが見つかりません");
          return;
        }
      }

      const response = await apiClient.get(`/api/files/${fileToFetch}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(response.data);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (err) {
      console.error("Could not open file:", err);
      alert("ファイルを開けませんでした");
    }
  }, [selectedContract]);

  const sourceFiles = useMemo(() => {
    if (!selectedContract?.filename) return [];
    return selectedContract.filename
      .split(",")
      .map((f) => f.trim())
      .filter((f) => f);
  }, [selectedContract]);

  return {
    handleOpenFile,
    sourceFiles,
  };
};